export default "__VITE_ASSET__D7nNeLO7__"